import { CertificateComponent } from './certificate/certificate.component';
import { AuthGuard } from './guard/auth.guard';
import { IndexComponent } from './index/index.component';
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginDEVComponent } from './login-dev/login-dev.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'SimulateLogin',
    component: LoginDEVComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'Certificate/:stno/:proG_CODE',
    component: CertificateComponent,
  },
  {
    path: '',
    component: IndexComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'ability',
        loadChildren: () => import('./module-page/ability/ability.module').then(m => m.AbilityModule),
      },
      {
        path: 'after-school',
        loadChildren: () => import('./module-page/after-school/after-school.module').then(m => m.AfterSchoolModule),
      },
      {
        path: 'grow',
        loadChildren: () => import('./module-page/grow/grow.module').then(m => m.GrowModule),
      },
      {
        path: 'personal',
        loadChildren: () => import('./module-page/personal/personal.module').then(m => m.PersonalModule),
      },
      {
        path: 'resource',
        loadChildren: () => import('./module-page/resource/resource.module').then(m => m.ResourceModule),
      },
      {
        path: 'short-cut',
        loadChildren: () => import('./module-page/short-cut/short-cut.module').then(m => m.ShortCutModule),
      },
      {
        path: 'situation',
        loadChildren: () => import('./module-page/situation/situation.module').then(m => m.SituationModule),
      },
      {
        path: 'achievement',
        loadChildren: () => import('./module-page/achievement/achievement.module').then(m => m.AchievementModule),
      },
      {
        path: 'paced',
        loadChildren: () => import('./module-page/paced/paced.module').then(m => m.PACEDModule),
      },
      {
        path: 'today',
        data: {

        },
        loadChildren: () => import('./module-page/today/today.module').then(m => m.TodayModule),
      },
      {
        path: 'rewards',
        data: {

        },
        loadChildren: () => import('./module-page/rewards/rewards.module').then(m => m.RewardsModule),
      },

      {
        path: '**',
        redirectTo: 'short-cut',
        pathMatch: 'full'
      }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload',
    // paramsInheritanceStrategy: 'always'
    // useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
